// extracted by mini-css-extract-plugin
export var divider = "_xx-0";